<template>
    <LayoutCookieConsentWrapper
        type="video"
        disabledMessage="Accept cookies to watch this video."
        :disabledPoster="poster ?? fallbackPoster"
        @cookies-accepted="autoplay = true"
    >
        <EmbedYoutubeLazyLoad :autoplay="autoplay" :idYoutube="idYoutube" class="w-full" />
    </LayoutCookieConsentWrapper>
</template>

<script>
export default {
    name: 'EmbedYoutube',
    data () {
        return {
            autoplay: false,
        };
    },
    props: {
        idYoutube: {
            type: String,
            required: true
        },
        poster: {
            type: String,
            required: false,
        }
    },
    computed: {
        fallbackPoster () {
            return `https://img.youtube.com/vi/${this.idYoutube}/mqdefault.jpg`;
        }
    }
};

</script>
